import { render, staticRenderFns } from "./DependencyView.vue?vue&type=template&id=705c10c6&scoped=true"
import script from "./DependencyView.vue?vue&type=script&lang=js"
export * from "./DependencyView.vue?vue&type=script&lang=js"
import style0 from "./DependencyView.vue?vue&type=style&index=0&id=705c10c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c10c6",
  null
  
)

export default component.exports